import { Empty, Table, Input,  Popover, Button, Radio, Tooltip } from "antd"
import { withForm } from "../../../../../helpers/withForm"
import * as cellFormat from "../../../../../helpers/cellFormat"
import { decoratedData } from "./data-decorator"
import numeral from "numeral"
import { LinkOutlined, QuestionCircleFilled } from "@ant-design/icons"
import { UploadButtonForm } from "../../../../shared"
import { useEffect, useState } from "react";
import { toFileList } from "../../../../../helpers"

function BudgetSummaryTable({ data, onChange, disabled }) {

  const [editData, setEditData] = useState([])

  useEffect(() => {

    const annualBudgets = data?.Implementer?.annualBudgets ?? []
  
    const decorated = decoratedData(data)
    const merged = decorated.map(yearRow => {
  
      const existing = annualBudgets.find(
        b => String(b.year) === String(yearRow.year)
      )
  
      if (existing) {
        return {
          ...yearRow,
          ...existing
        }
      }

      return yearRow
    })
  
    setEditData(merged)
  
  }, [data])

  const getValue = (row, type) => {
    const amount = row[type]
    const total = amount !== 0 ? row.total : 1

    const percentage = ((amount * 100) / total).toFixed(2)
    
    return {percentage:`(${percentage}%)`, value:numeral(amount).format("0,0.00")}
  }

  const updateDocuments = (docs,row) =>{

    const newData = editData.map((item)=>{
      if(item.year === row.year){
        
        return {...item, documents:docs}

      }else{return item}
    })

    setEditData(newData)
    onChange(newData)
  }

   const editauditedFinancials = (data,row) =>{

    const newData = editData.map((item)=>{
      if(item.year === row.year){
        
        return {...item, auditedFinancials:data}

      }else{return item}
    })

    setEditData(newData)
    onChange(newData)
  }

  const editInfo = (data,row, key) => {
    const newData = editData.map((item)=>{
      if(item.year === row.year){
        const newItem = {
          ...item,
          [key]: parseFloat(data.replace(/,/g, ""))
        }
      
        const total =
          Number(newItem.private) +
          Number(newItem.public) +
          Number(newItem.own)
      
        return {...newItem, total:total}
      }
      else{return item}
    })

    setEditData(newData)
    onChange(newData)
  }

  const onDoneFile = (files, data, documents, type) => {
    const newDocuments = files?.map(({ name, url }) => ({ name, url, type }))
    
    updateDocuments([...documents,...newDocuments],data)
  }

  const onRemoveFile = ({ url }, files, data, type ) => {
    const documents = files?.filter(doc => doc.url !== url)
  
    updateDocuments(documents,data)
  }


  const content = (documents, row) => {
    
    const estadosResultados = documents.filter(item => item.type === "EstadosResultados");
    const balanceGeneral = documents.filter(item => item.type === "balanceGeneral");
    const balanzaDeComprobacion = documents.filter(item => item.type === "balanzaDeComprobacion");
    const estadoDeFlujoDeEfectivo = documents.filter(item => item.type === "estadoDeFlujoDeEfectivo");
    const estadoDeCambiosPatrimonioNeto = documents.filter(item => item.type === "estadoDeCambiosPatrimonioNeto");

    return(
     <div style={{ width: "300px", height:"400px", overflowX:"hidden", overflowY:"scroll" }}>
          <p>Estado de resultados</p>
          <UploadButtonForm
            disabled={disabled}
            fileList={toFileList(estadosResultados)}
            onRemoveFile={data => onRemoveFile(data, documents, row)}
            onChange={file => onDoneFile(file, row,documents,"EstadosResultados")}
            maxFile={1}
          >
            Adjuntar
          </UploadButtonForm><br/>
          <p>Balance general</p>
          <UploadButtonForm
            disabled={disabled}
            fileList={toFileList(balanceGeneral)}
            onRemoveFile={data => onRemoveFile(data, documents, row)}
            onChange={file => onDoneFile(file, row,documents,"balanceGeneral")}
            maxFile={1}
          >
            Adjuntar
          </UploadButtonForm><br/>
          <p>Balanza de comprobación</p>
          <UploadButtonForm
            disabled={disabled}
            fileList={toFileList(balanzaDeComprobacion)}
            onRemoveFile={data => onRemoveFile(data, documents, row)}
            onChange={file => onDoneFile(file, row,documents,"balanzaDeComprobacion")}
            maxFile={1}
          >
            Adjuntar
          </UploadButtonForm><br/>
          <p>Estado de flujo de efectivo</p>
          <UploadButtonForm
            disabled={disabled}
            fileList={toFileList(estadoDeFlujoDeEfectivo)}
            onRemoveFile={data => onRemoveFile(data, documents, row)}
            onChange={file => onDoneFile(file, row,documents,"estadoDeFlujoDeEfectivo")}
            maxFile={1}
          >
            Adjuntar
          </UploadButtonForm><br/>
          <p>Estado de cambios en el patrimonio neto</p>
          <UploadButtonForm
            disabled={disabled}
            fileList={toFileList(estadoDeCambiosPatrimonioNeto)}
            onRemoveFile={data => onRemoveFile(data, documents, row)}
            onChange={file => onDoneFile(file, row,documents,"estadoDeCambiosPatrimonioNeto")}
            maxFile={1}
          >
            Adjuntar
          </UploadButtonForm><br/>
          <p>¿Los estados financieros están dictaminados?</p>
        <Radio.Group disabled={disabled} defaultValue={row.auditedFinancials} onChange={({target})=>editauditedFinancials(target.value,row)}>
          <Radio value={true}>Sí</Radio>
          <Radio value={false}>No</Radio>
        </Radio.Group>
        
      </div>
  )}
  return (
    <>
      <Table
        dataSource={editData.sort((a, b) => Number(b.year) - Number(a.year))}
        pagination={false}
        locale={{emptyText: <Empty description="Agrega proyectos en la sección anterior para generar el resumen" />}}>
        <Table.Column
          title="Año"
          key="year"
          dataIndex="year" />
        <Table.Column
          title={
            
            <Tooltip title={<>Recursos que la Implementadora genera directamente, como cuotas de recuperación por sus servicios, venta de productos, o eventos de recaudación de fondos.</>}>
              Ingresos Propios <QuestionCircleFilled style={{ fontSize: "12px" }} />
            </Tooltip>
            
          }
          dataIndex="own"
          render={(t, row) => (<>
          <Input
          disabled={disabled}
          onBlur={({target}) => editInfo(target.value,row,"own")} 
          addonBefore="$" addonAfter={getValue(row, "own").percentage} defaultValue={getValue(row, "own").value} />
          </>)} />
        <Table.Column
          title={
            <Tooltip title={<>Fondos recibidos de gobierno (municipal, estatal o federal) a través de convocatorias, subsidios o contratos.</>}>
              Aportaciones de Instituciones Públicas <QuestionCircleFilled style={{ fontSize: "12px" }} />
            </Tooltip>
          }
          dataIndex="public"
          render={(t, row) => (<>
          <Input 
          disabled={disabled}
          onBlur={({target}) => editInfo(target.value,row, "public")}
          addonBefore="$" addonAfter={getValue(row, "public").percentage} defaultValue={getValue(row, "public").value} />
          </>)} />
        <Table.Column
          title={
            <Tooltip title={<>Donativos en efectivo de empresas, fundaciones (como FECHAC y FICOSEC), o de personas a través de campañas específicas (padrinos, redondeo).</>}>
              Aportaciones del Sector Privado <QuestionCircleFilled style={{ fontSize: "12px" }} />
            </Tooltip>
          }
          dataIndex="private"
          render={(t, row) => (<>
          <Input 
          disabled={disabled}
          onBlur={({target}) => editInfo(target.value,row, "private")}
          addonBefore="$" addonAfter={getValue(row, "private").percentage} defaultValue={getValue(row, "private").value} />
          </>)} />
        <Table.Column
          title="Ingresos Totales"
          dataIndex="total"
          render={cellFormat.money} />
          <Table.Column
          title={
            <Tooltip title={<>Los estados financieros son de cada ejercicio fiscal (enero-diciembre del año respectivo). Se deben cargar documentos en formato PDF y, al interior de cada documento, deben incluirse el nombre, la firma y la cédula profesional del contador/a que los elaboró.</>}>
              Estados Financieros <QuestionCircleFilled style={{ fontSize: "12px" }} />
            </Tooltip>
          }
          dataIndex="documents"
          render={(t, row) => (
            <Popover
              id="documents"
              name="documents"
              placement="right"
              content={content(row.documents ?? [], row)}
              title={""}
              trigger="click">
              <Button
                shape="circle"
                icon={<LinkOutlined />} />
            </Popover>
          )} />

      </Table>
      (%) Porcentaje de financiamiento del total anual
    </>
  )
}

export default withForm(BudgetSummaryTable)
